import i18n from '@/i18n'
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import ReportHeading from '@/Utils/report-head-awareness'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
// import { dateFormat } from '@/Utils/fliter'
const exportPdfDetails = async (baseUrl, uri, orgId, reportTitle, data, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = [
        {
          columns: reportHeadData.reportHeadColumn
        },
        { text: reportHeadData.orgName, style: 'orgName', alignment: 'center' },
        { text: reportHeadData.address, style: 'address', alignment: 'center' }
      ]
      pdfContent.push({ text: reportTitle, style: 'header2', alignment: 'center' })

      const allRowsHead = [
        [
          { text: vm.$t('globalTrans.fiscal_year'), alignment: 'left', style: 'th' },
          { text: ':', style: 'th', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.year_name : data.year_name_bn, alignment: 'left', style: 'td' },
          { text: vm.$t('assitive_device_management.month'), alignment: 'left', style: 'th' },
          { text: ':', style: 'th', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.month_name : data.month_name_bn, alignment: 'left', style: 'td' }
        ]
      ]
      allRowsHead.push([
          { text: vm.$t('assitive_device_management.donation_form'), alignment: 'left', style: 'th' },
          { text: ':', style: 'th', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.donation_form : data.donation_form_bn, alignment: 'left', style: 'td' },
          { text: vm.$t('assitive_device_management.donor_details'), alignment: 'left', style: 'th' },
          { text: ':', style: 'th', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.donor_description : data.donor_description, alignment: 'left', style: 'td' }
      ])
      allRowsHead.push([
        { text: vm.$t('assitive_device_management.donation_type'), alignment: 'left', style: 'th' },
        { text: ':', style: 'th', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.donation_type_name : data.donation_type_name_bn, alignment: 'left', style: 'td' },
        { text: vm.$t('assitive_device_management.idsc_center'), alignment: 'left', style: 'th' },
        { text: ':', style: 'th', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.center_name : data.center_name_bn, alignment: 'left', style: 'td' }
      ])
      if (data.donation_type_id === 1) {
        allRowsHead.push([
            { text: vm.$t('assitive_device_management.assistive_device_name'), alignment: 'left', style: 'th' },
            { text: ':', style: 'th', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.device_name : data.device_name_bn, alignment: 'left', style: 'td' },
            { text: vm.$t('assitive_device_management.quantity_pice'), alignment: 'left', style: 'th' },
            { text: ':', style: 'th', alignment: 'center' },
            { text: vm.$n(data.device_quantity), alignment: 'left', style: 'td' }
          ])
      }
      if (data.donation_type_id === 2) {
        allRowsHead.push([
            { text: vm.$t('assitive_device_management.amount'), alignment: 'left', style: 'th' },
            { text: ':', style: 'th', alignment: 'center' },
            { text: vm.$n(data.amount), alignment: 'left', style: 'td' },
            {},
            {},
            {}
          ])
      }
      if (data.donation_type_id === 3) {
        allRowsHead.push([
            { text: vm.$t('assitive_device_management.quantity_pice'), alignment: 'left', style: 'th' },
            { text: ':', style: 'th', alignment: 'center' },
            { text: vm.$n(data.medicine_quantity), alignment: 'left', style: 'td' },
            {},
            {},
            {}
          ])
      }
      if (data.description) {
        allRowsHead.push([
          { text: vm.$t('globalTrans.description'), alignment: 'left', style: 'th' },
          { text: ':', style: 'th', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.description : data.description, alignment: 'left', style: 'td' },
          {},
          {},
          {}
        ])
      }
      pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['20%', '2%', '28%', '20%', '2%', '28%'],
            body: allRowsHead
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        pdfContent.push({ text: '', style: 'fertilizer' })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social Welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portable',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
          th: {
            fontSize: (i18n.locale === 'bn') ? 10 : 9,
            bold: true,
            margin: [3, 3, 3, 3]
          },
            th1: {
                fontSize: 9
            },
            td: {
                fontSize: (i18n.locale === 'bn') ? 10 : 9,
                margin: [3, 3, 3, 3]
            },
            td1: {
              fontSize: (i18n.locale === 'bn') ? 8 : 7,
              margin: [3, 3, 3, 3]
            },
            design: {
              margin: [53, 3, 50, 3]
            },
            search: {
              fontSize: (i18n.locale === 'bn') ? 10 : 8,
              margin: [3, 3, 3, 3]
            },
            searchtwo: {
              fontSize: (i18n.locale === 'bn') ? 10 : 8,
              margin: [63, 13, 13, 13]
            },
            fertilizer: {
              margin: [5, 0, 0, 5]
            },
            header: {
              fontSize: 12,
              margin: [0, 0, 0, 4]
            },
            header2: {
              fontSize: 14,
              margin: [0, 10, 0, 20]
            },
            headerPort1: {
              fontSize: 10,
              margin: [0, 20, 0, 5]
            },
            headerPort: {
              fontSize: 10,
              margin: [0, 4, 0, 15]
            },
            krishi: {
              margin: [0, -5, 0, 15],
              alignment: 'center'
            },
            header3: {
              fontSize: 9,
              margin: [0, 0, 0, 0]
            },
            govt_info: {
              margin: [0, 3, 0, 0],
              fontSize: 15,
              alignment: 'center'
            },
            address: {
              fontSize: 9,
              margin: [10, 0, 0, 0]
            },
            tdtwo: {
              fontSize: 10,
              margin: [0, 0, 0, 0]
            },
            td2: {
                border: 0,
                fontSize: 13,
                alignment: 'center'
              },
            AddressTable: {
              margin: [0, 0, 250, 0]
            },
            tableHeader: {
              fontSize: 11
            },
            noborder: {
               border: 0
            },
            left_logo: {
              borderRadius: 50
            },
            mainName: {
              margin: [8, 0, 0, 20]
            },
            tableExample: {
              fontSize: 11,
              margin: [0, 10, 10, 10]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
